// store/slices/telematicsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const telematicsSlice = createSlice({
  name: 'telematics',
  initialState: {
    activeTracking: {},  // Keyed by load_id
    trackingHistory: {}, // Historical data keyed by load_id
    lastUpdate: null,
  },
  reducers: {
    updateTelematics: (state, action) => {
      const { load_id, data } = action.payload;
      
      // Store the data directly as received
      state.activeTracking[load_id] = {
        location: data.location,
        timestamp: data.timestamp,
        vehicle: data.vehicle,
        speed: data.speed,           // Use direct speed value
        fuel_level: data.fuel_level  // Use direct fuel_level value
      };
      
      // Keep historical data
      if (!state.trackingHistory[load_id]) {
        state.trackingHistory[load_id] = [];
      }
      state.trackingHistory[load_id].push({
        ...data,
        speed: data.speed,
        fuel_level: data.fuel_level
      });
      
      // Limit history to last 100 points
      if (state.trackingHistory[load_id].length > 100) {
        state.trackingHistory[load_id].shift();
      }
    },
    clearLoadTracking: (state, action) => {
      const load_id = action.payload;
      delete state.activeTracking[load_id];
      delete state.trackingHistory[load_id];
    }
  }
});

export const { updateTelematics, clearLoadTracking } = telematicsSlice.actions;
export default telematicsSlice.reducer;